<template>
  <VRow class="fill-height skeleton">
    <VCol cols="12" md="6" class="px-5 px-md-12 pr-md-10">
      <VRow>
        <VCol cols="12" md="6">
          <VSkeletonLoader :boilerplate="boilerplate" type="heading" class="mb-2" />
          <VSkeletonLoader :boilerplate="boilerplate" type="text" width="150" />
        </VCol>
        <VCol cols="12" md="6" class="d-flex flex-column align-end">
          <VRating
            dense
            background-color="grey lighten-3"
            empty-icon="mdi-star"
            full-icon="mdi-star"
            size="16"
            readonly
            class="mb-2"
          />
          <VSkeletonLoader :boilerplate="boilerplate" type="text" width="150" />
        </VCol>
      </VRow>
      <VRow>
        <VCol cols="12" md="6">
          <VSkeletonLoader :boilerplate="boilerplate" type="text" width="250" />
        </VCol>
        <VCol cols="12" md="6" />
      </VRow>
      <VRow>
        <VCol cols="12" md="6">
          <VSkeletonLoader :boilerplate="boilerplate" type="text, text, text" width="150" />
        </VCol>
        <VCol cols="12" md="6" class="d-flex flex-column justify-end align-end">
          <VSkeletonLoader :boilerplate="boilerplate" type="text, text" width="150" />
        </VCol>
        <VCol cols="12">
          <VResponsive
            :aspect-ratio="16 / 9"
            class="overflow-hidden"
          >
            <VCard elevation="0" class="grey lighten-2" width="100%" height="100%" />
          </VResponsive>
        </VCol>
      </VRow>
      <div class="d-flex justify-center align-center">
        <VSkeletonLoader :boilerplate="boilerplate" type="text" width="150" />
        <VSkeletonLoader :boilerplate="boilerplate" type="text" width="30" class="mx-2" />
        <VSkeletonLoader :boilerplate="boilerplate" type="text" width="150" />
      </div>
      <VRow>
        <VCol col="6">
          <VSkeletonLoader
            :boilerplate="boilerplate"
            type="list-item-avatar-two-line"
            class="miracle"
          />
        </VCol>
        <VCol col="6">
          <VSkeletonLoader :boilerplate="boilerplate" type="list-item-avatar-two-line" />
        </VCol>
      </VRow>
    </VCol>
    <VCol cols="12" md="6" class="py-0 pa-md-0">
      <VCard outlined flat tile class="right-panel pa-md-0 fill-height light-background">
        <div class="candidate-tabs-panel fill-height pr-md-2">
          <VTabs
            background-color="transparent"
            color="dark"
            slider-size="4"
            slider-color="primary"
            :grow="$vuetify.breakpoint.smAndDown"
            :show-arrows="false"
            class="candidate-tabs-panel__tabs fill-height pt-md-4"
          >
            <VTab class="mr-6 ml-1 ml-md-12" :ripple="false">
              <VSkeletonLoader :boilerplate="boilerplate" type="text" width="100" />
            </VTab>
            <VTab class="mr-6" :ripple="false">
              <VSkeletonLoader :boilerplate="boilerplate" type="text" width="80" />
            </VTab>
            <VTab class="mr-6" :ripple="false">
              <VSkeletonLoader :boilerplate="boilerplate" type="text" width="120" />
            </VTab>
            <VTabItem>
              <div
                class="candidate-log d-flex flex-column justify-end fill-height overflow-y-hidden"
              >
                <VSheet class="elevation-5 mt-n3" width="100%" height="5" />
                <div
                  class="messages-container pa-2 pa-md-5 flex-grow-1 overflow-y-auto"
                  :style="messagesContainerStyle"
                >
                  <div
                    v-for="i in 15"
                    :key="i"
                    class="
                      candidate-log-messages-block
                      d-flex flex-column
                      flex-md-row
                      align-start
                      pa-2
                      pa-md-3
                    "
                  >
                    <VSkeletonLoader :boilerplate="boilerplate" type="avatar" class="mr-2" />
                    <VSkeletonLoader
                      :boilerplate="boilerplate"
                      type="text"
                      width="70"
                      class="mr-2"
                    />
                    <VSkeletonLoader :boilerplate="boilerplate" type="paragraph" width="70%" />
                  </div>
                </div>
                <div class="elevation-5 pa-2 pa-md-5">
                  <div class="candidate-log-create-form">
                    <div class="candidate-log-create-form__textarea mb-3">
                      <VTextarea
                        outlined
                        :rows="$vuetify.breakpoint.mdAndUp ? 3 : 5"
                        hide-details
                        background-color="#fff"
                        disabled
                        class="body-2"
                      >
                        <template #label>
                          <span class="body-2">
                            <VSkeletonLoader :boilerplate="boilerplate" type="text" width="250" />
                          </span>
                        </template>
                        <template v-if="$vuetify.breakpoint.mdAndUp" #append>
                          <VBtn
                            x-small
                            depressed
                            class="candidate-log-create-form__send-comment mb-3"
                            color="success"
                            disabled
                          >
                            <VIcon>
                              M17.5,6.5c-0.3,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.3,
                              0.4-0.3,0.7v4c0,0.3-0.1,
                              0.5-0.3,0.7c-0.2,0.2-0.4,0.3-0.7,0.3
                              H8.9l1.3-1.3c0.2-0.2,0.3-0.4,0.3-0.7s-0.1-0.5-0.3-0.7C10,
                              9.6,9.8,9.5,9.5,9.5C9.2,9.5,9,9.6,8.8,9.8l-3,3
                              c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.2-0.1,0.5,0,0.8c0,0.1,0.1,0.2,0.2,
                              0.3l3,3c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0.1,0.3,0.1,0.4,0.1
                              c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.2,
                              0.2-0.3c0.1-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.3-0.1-0.4
                              c-0.1-0.1-0.1-0.2-0.2-0.3l-1.3-1.3h6.6c0.8,0,1.6-0.3,
                              2.1-0.9c0.6-0.6,0.9-1.3,0.9-2.1v-4c0-0.3-0.1-0.5-0.3-0.7
                              C18,6.6,17.8,6.5,17.5,6.5z
                            </VIcon>
                          </VBtn>
                        </template>
                      </VTextarea>
                    </div>
                    <VCheckbox
                      hide-details
                      disabled
                      :label="$t('bindTimeStamp')"
                    >
                      <template #label>
                        <span class="body-2 pt-1">
                          <VSkeletonLoader :boilerplate="boilerplate" type="text" width="250" />
                        </span>
                      </template>
                    </VCheckbox>
                    <VBtn
                      v-if="$vuetify.breakpoint.smAndDown"
                      color="success"
                      class="mt-3"
                    >
                      <VSkeletonLoader :boilerplate="boilerplate" type="text" width="100" />
                    </VBtn>
                  </div>
                </div>
              </div>
            </VTabItem>
          </VTabs>
        </div>
      </VCard>
    </VCol>
  </VRow>
</template>
<script>
export default {
  name: 'Skeleton',
  data() {
    return {
      boilerplate: true,
    };
  },
  computed: {
    messagesContainerStyle() {
      return { minHeight: this.$vuetify.breakpoint.smAndDown ? 'calc(100vh - 324px)' : '' };
    },
  },
};
</script>

<style lang="scss" scoped>
.miracle {
  transform: scaleX(-1);
}

.candidate-tabs-panel {
  &::v-deep * {
    box-sizing: border-box;
  }
}

.candidate-tabs-panel__tabs {
  &::v-deep {
    .v-tabs-bar--is-mobile {
      .v-slide-group__prev {
        display: none !important;
      }
    }

    .v-tabs-bar {
      margin-bottom: 0;
    }

    .v-tabs-items {
      height: calc(100% - 48px);

      .v-window__container {
        height: 100%;

        .v-window-item {
          height: 100%;
        }
      }

    }
  }
}

.messages-container {
  width: 100%;
  height: 0px;
}

.candidate-log-create-form__textarea {
  &::v-deep {
    .v-textarea {
      .v-input__append-inner {
        align-self: flex-end;
      }
    }
  }
}

.candidate-log-messages-block {
  line-height: 1.43em;
  color: #212121;
  border-bottom: 0.5px dashed rgba(#000000, 0.32);
  background-repeat: no-repeat;
  background-position: 5px 7px;
  word-break: break-word;

  .candidate-log-messages-block__date {
    width: 80px;
    line-height: 28px;
    color: #757575;

    i {
      font-style: normal;
      color: #c0c0c0;
    }
  }
}

.candidate-log-messages-block-mdAndUp {
  padding-left: 60px;
  background-position: 10px 11px;
}

.candidate-log-messages-block__content-mdAndUp {
  width: calc(100% - 90px);
}

@media #{map-get($display-breakpoints, 'md-and-up')} {
  .skeleton {
    height: 700px;
  }
}
</style>

<style lang="scss">
.candidate-tabs-panel .v-tabs-bar {
  padding-left: 20px;
}
</style>

<i18n locale="en" lang="yaml">
  bindTimeStamp: Connect to timestamp
</i18n>

<i18n locale="ru" lang="yaml">
  bindTimeStamp: Привязать к временной метке
</i18n>
